module.exports = __webpack_public_path__ + "static/media/6_School of the animals_FR.2c3eb845.txt";